import React, { useEffect, useRef } from "react";
import { Box, Button, Typography } from "@mui/joy";
import GeekPlayer from "../../../../components/GeekPlayer";

interface HeroVideoProps {
  videoId: string;
  isActive: boolean;
  muted: boolean;
  setMuted: (muted: boolean) => void;
  playing: boolean;
  setPlaying: (playing: boolean) => void;
  onVisibilityChange: (isVisible: boolean) => void;
}

const HeroVideo: React.FC<HeroVideoProps> = ({ 
  videoId,
  isActive, 
  muted, 
  setMuted, 
  playing, 
  setPlaying, 
  onVisibilityChange
}) => {
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onVisibilityChange(true);
          } else {
            onVisibilityChange(false);
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: '0px 0px -20% 0px'
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, [onVisibilityChange]);


  return (
    <Box
      ref={videoRef}
      sx={{
        width: "100%",
        maxWidth: { xs: "600px", md: "none" },
        aspectRatio: "3/4",
        position: "relative",
        mx: { xs: "auto", md: 0 },
        borderRadius: "16px",
        boxShadow: "0 2px 18px rgba(0,0,0,0.2)",
      }}
    >
      <GeekPlayer
        key={videoId}
        videoId={videoId}
        playing={isActive && playing}
        setGlobalPlaying={setPlaying}
        globalMuted={muted}
        setGlobalMuted={setMuted}
      />
    </Box>
  );
};

export default HeroVideo; 